//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: null,
    col: {
      type: Number,
      default: 3
    }
  },
  data: () => ({
    imageList: [],
    width: '33.333333%',
    height: 'auto'
  }),

  computed: {
    objStyle () {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      }
    }
  },

  methods: {
    initHeight () {
      this.width = this.$el.clientWidth / this.col
      this.height = this.width
    },
    initList () {
      if (typeof this.list === 'string') {
        this.imageList = this.list.split(',')
      } else if (typeof this.list === 'object') {
        this.imageList = this.list
      } else {
      }
    },
    // 微信相册
    albumView (src, list) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': list.map(src => {
            return src + '?x-oss-process=style/large'
          }),
          'current': src + '?x-oss-process=style/large'
        })
      }
    }
  },

  mounted () {
    this.initHeight()
    this.initList()
  },
  watch: {
    col (val) {
      this.initHeight()
    },
    list (val) {
      this.initList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/image-group/index.vue